'use client'

import AuditForm from '@/components/AuditForm'

const REVIEWS_URL =
  'https://www.google.com/maps/place/SmartMetrics/@46.423669,-129.9427085,3z/data=!4m8!3m7!1s0x80d954abfbff295d:0x9f066acf6ab522e4!8m2!3d46.423669!4d-129.9427086!9m1!1b1!16s%2Fg%2F11fy4q0lsm?entry=ttu'

export default function RequestQuoteSidebar({
  serviceName,
}: {
  serviceName: string
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-100 bg-slate-50 px-5 py-4">
        
        <h2 className="mt-0.5 text-xl font-bold text-slate-900">Request a Quote</h2>
        
      </div>

      <div className="px-5 py-5">
        <div className="mb-4 flex items-center gap-3">
          <div className="relative shrink-0">
            <img
              src="/images/tomas.jpg"
              alt="Tomas"
              width={40}
              height={40}
              className="h-10 w-10 rounded-full object-cover ring-2 ring-white shadow-sm"
            />
            <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full border-2 border-white bg-emerald-400" />
          </div>
          <div>
            <p className="text-sm font-bold leading-tight text-slate-900">Work with Tomas</p>
            <p className="text-xs text-slate-500">Lead Generation Expert</p>
          </div>
        </div>

        <div className="mb-5 flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-slate-100 pb-4">
          <div className="flex items-center gap-1.5">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <span className="text-sm font-bold text-slate-800">5.0</span>
            <a
              href={REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-600 underline hover:text-blue-800"
            >
              Client Reviews
            </a>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-slate-500">
            <span className="h-2 w-2 rounded-full bg-emerald-400" />
            Available now
          </div>
        </div>

        <AuditForm
          layout="column"
          serviceType="monthly"
          serviceName={serviceName}
          formSource="service-detail-sidebar"
          buttonText="Send Request"
          ctaText="Request a Quote"
          stackFields
          initialFocusArea={`Interested in: ${serviceName}`}
        />
      </div>
    </div>
  )
}
